module.exports = __webpack_public_path__ + "static/media/back.eaf311b7.svg";